/// <amd-module name="Test/TestPlansHubRefresh/PostTTIModule/Redux/PostTTISaga" />
import { effects, SagaIterator } from "redux-saga";
import { ActionsOfType } from "redux/Utils/ActionHelper";
import { IVssPageContext } from "VSS/Platform/Context";
import { PostTTIActions, PostTTIActionsTypes } from "./PostTTIActions";
import { errorHandledSaga } from "Test/TestPlansHubRefresh/TestHub/Util";

export function* PostTTISaga(): SagaIterator {
    yield effects.takeLatest(PostTTIActionsTypes.loadPostTTIModules, _loadPostTTIModules);
}

export function* loadPostTTIModules(action: ActionsOfType<PostTTIActions, PostTTIActionsTypes.loadPostTTIModules>): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const legacyPlatformService = (yield effects.call([pageContext, pageContext.getService], "ILegacyPlatformService")) as any;
    yield effects.call(
        [legacyPlatformService, legacyPlatformService.loadModules],
        [
            "WorkItemTracking/SharedScripts/WorkItemDialogShim",
            "TestManagement/Scripts/Shared/AssignConfigDialogProxy",
            "TestManagement/Scripts/Shared/AddToExistingTestCasesProxy",
            "TestManagement/Scripts/Shared/GridViewProxyComponent",
            "WorkItemTracking/Scripts/TFS.WorkItemTracking.Controls",
            "TestManagement/Scripts/TFS.TestManagement.Controls"
        ]
    );
}

const _loadPostTTIModules = errorHandledSaga(function*(
    action: ActionsOfType<PostTTIActions, PostTTIActionsTypes.loadPostTTIModules>
): SagaIterator {
    yield effects.call(loadPostTTIModules, action);
});